
<!-- code has ben changed because the PA will now be ordering their padge instead of the employerName
all labels that refer to the employer will now refer the PA but the backend database will remain the same pointing to employer -->
<div class="container-form" (window:resize)="onResize()">
    <mat-form-field appearance="outline" class="form-field">
            <mat-label>Main Employer Name</mat-label>
            <input matInput [formControl]="employeeNameControl" [errorStateMatcher]="matcher" [(ngModel)]="user.employerName">
            <mat-error *ngIf="employeeNameControl.hasError('required')">
                Employee Name is <strong>required</strong>
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Personal Assistant Name</mat-label>
            <input matInput [formControl]="paNameControl" [errorStateMatcher]="matcher" [(ngModel)]="user.paName">
            <mat-error *ngIf="paNameControl.hasError('required')">
                Personal Assistant name is <strong>required</strong>
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Personal Assistant Email</mat-label>
            <input matInput type="email" [formControl]="employeeEmailControl" [errorStateMatcher]="matcher" [(ngModel)]="user.email">
            <mat-error *ngIf="employeeEmailControl.hasError('email') && !employeeEmailControl.hasError('required')">
                Please enter a valid email address
            </mat-error>
            <mat-error *ngIf="employeeEmailControl.hasError('required')">
                Email is <strong>required</strong>
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Confirm Email</mat-label>
            <input matInput type="email" [formControl]="confirmEmailControl" [errorStateMatcher]="matcher" [(ngModel)]="confirmEmail">
            <mat-error *ngIf="checkEmail();">
                Email does not match
            </mat-error>
            <mat-error *ngIf="confirmEmailControl.hasError('required')">
                Confirm Email is <strong>required</strong>
            </mat-error>
        </mat-form-field>

        <app-google-location-finder [address]="address" addressType="geocode" (setAddress)="onAddressLookup($event)"></app-google-location-finder>

        <mat-form-field appearance="outline">
            <mat-label>County</mat-label>
            <input matInput [readonly]="true" [(ngModel)]="user.county" [disabled]="user.address == ''">
        </mat-form-field>

    <div class="pa-container">
        <div class="lol" [ngStyle]="{'justify-content': user.employerName === '' || user.paName === '' || user.email === '' || hideBadgeInfo ? 'center': ''}"
             [ngClass]="{'hide-border': hideBadgeInfo}">
            <div>
                <img class="pa-badge-img" [src]="url" height="200px" width="175px">
                <div style="position: relative; bottom: 3%;">
                    <input type="file" class="input-upload-picture" id="uploadImage" (change)="onselectFile($event)">
                    <label for="uploadImage" class="pa-picture-upload">Upload Picture</label>
                </div>
            </div>
            <div class="pa-badge-info" *ngIf="user.employerName !== '' && user.paName !== '' && user.email !== '' && !hideBadgeInfo">
                <div>
                    <span><b>Employer:</b> {{ user.employerName }}</span>
                </div>
                <div>
                    <span><b>Personal Assistant:</b> {{ user.paName }}</span>
                </div>
                <div>
                    <span><b>Personal Assistant Email:</b> {{ user.email }}</span>
                </div>
                <div>
                    <button mat-raised-button class="preview-btn"  (click)="saveToBasket();" *ngIf="!isEdit && !checkUserObject()">
                        <mat-icon>add</mat-icon><span> Add to basket</span>
                    </button>
                    <button mat-raised-button class="preview-btn"  (click)="editBadge();" *ngIf="isEdit">
                        <mat-icon>save</mat-icon><span> Save</span>
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="hideBadgeInfo">
            <button mat-raised-button class="preview-btn"  (click)="saveToBasket();" *ngIf="!isEdit && !checkUserObject()" [ngStyle]="{'left': hideBadgeInfo ? '0%' : '10%'}">
                <mat-icon>add</mat-icon><span> Add to basket</span>
            </button>
            <button mat-raised-button class="preview-btn"  (click)="editBadge();" *ngIf="isEdit" [ngStyle]="{'left': hideBadgeInfo ? '0%' : '10%'}">
                <mat-icon>save</mat-icon><span> Save</span>
            </button>
        </div>
    </div>
</div>
